import InstallAppButton from '@/components/InstallAppButton';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.tovias.twa';

export const isIOSDevice = () => typeof navigator !== 'undefined'
  && (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const GooglePlayBadge = ({ className = 'h-12', testid = 'google-play-badge' }) => (
  <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid={testid}
    className="inline-block transition-transform duration-200 hover:scale-[1.03] active:scale-95" aria-label="Disponible en Google Play">
    <img src="/google-play-badge-es.png" alt="Disponible en Google Play" className={`${className} w-auto`} loading="lazy" />
  </a>
);

// Google Play + instalación desde el navegador (iPhone, ordenador). En iPhone, el badge de Play no aplica.
export const GetTheAppButton = ({ className }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="get-app-options">
    {!isIOSDevice() && <GooglePlayBadge className={className} />}
    <InstallAppButton />
  </div>
);

export default GooglePlayBadge;
